import { useMemo } from "react";
import { username } from "../helpers";

export type EnabledForPermissions = ReadonlyArray<string> | null | undefined;

interface UseCanViewByOwnershipPermissionArgs {
  enabledFor: EnabledForPermissions;
  entryBy?: string;
  assignedTo?: string;
  /**
   * When false, permission gating is disabled and the hook returns true.
   * (Used for cases like: no investigation status yet => allow viewing.)
   */
  gate?: boolean;
}

export function useCanViewByOwnershipPermission({
  enabledFor,
  entryBy,
  assignedTo,
  gate = true,
}: UseCanViewByOwnershipPermissionArgs): boolean {
  return useMemo(() => {
    if (!gate) return true;

    if (!enabledFor?.length) return false;
    if (enabledFor.includes("SELF")) return true;

    const currentUser = username();
    if (!currentUser) return false;

    return (
      (enabledFor.includes("ASSIGNED-USERS") &&
        Boolean(assignedTo) &&
        assignedTo === currentUser) ||
      (enabledFor.includes("ENTRY-USERS") &&
        Boolean(entryBy) &&
        entryBy === currentUser)
    );
  }, [assignedTo, enabledFor, entryBy, gate]);
}
